import { IS_MAINNET } from "../constant"

// TODO: might need to update this URL
const BASE_URL = `https://s3.amazonaws.com/staking.perp.fi/${IS_MAINNET ? "production" : "staging"}`

export function fetchHelper(endpoint: string) {
    return window.fetch(`${BASE_URL}${endpoint}`).then(async response => {
        const data = await response.json()
        if (response.ok) {
            return data
        } else {
            return Promise.reject(data)
        }
    })
}

export function getReportWeeklyDetailForReward(week: string, hash: string) {
    return fetchHelper(`/${week}/${hash}.json`)
}

export function getExchangeRate(from: string, to: string) {
    return fetch(`https://api.coingecko.com/api/v3/simple/price?ids=${from}&vs_currencies=${to}`)
}
